'use strict';

wbApp.controller('MembershipCtrl', ['$scope', '$modal', '$translate', '$filter', '$window', 'membershipSvc', 'membershipStudentSvc', 'securitySvc',
    function ($scope, $modal, $translate, $filter, $window, membershipSvc, membershipStudentSvc, securitySvc) {

    $scope.memberships = membershipSvc.getAllAsync();

    $scope.$on('refreshData', function (e, data) {
        $scope.memberships = membershipSvc.getAllAsync(true);
        setSelectedMembership(null);
    });

    $scope.gridSettings = {
        name: 'memberships',
        columns: [
            { dataField: 'id', caption: $translate.instant('TXT_LBL_ID'), dataType: 'number', visible: false },
            { dataField: 'name', caption: $translate.instant('TXT_LBL_NAME'), dataType: 'string', sortOrder: 'asc', width: '220px' },
            { dataField: 'description', caption: $translate.instant('TXT_LBL_DESCRIPTION'), dataType: 'string'},
            { dataField: 'price', caption: $translate.instant('TXT_LBL_PRICE'), dataType: 'number', format: { type: 'currency', precision: 2 }, width: '100px' },
            {
                dataField: 'discountPct', caption: $translate.instant('TXT_LBL_DISCOUNT_PCT'), dataType: 'number',
                format: function (value) {
                    return $filter('wbPercent')(value);
                }, width: '70px'
            },
            { dataField: 'isMandatory', caption: $translate.instant('TXT_LBL_IS_MANDATORY'), dataType: 'boolean', width: '60px' },
            {
                dataField: 'validityPeriodInDays',
                caption: $translate.instant('TXT_LBL_ACTIVE'),
                dataType: 'boolean',
                calculateCellValue: function (rowData) {
                    if (rowData.validityPeriodInDays) {
                        return true;
                    }

                    var validFrom = moment(rowData.validFrom);
                    var validTo = moment(rowData.validTo);

                    return moment().isBetween(validFrom, validTo);
                },
                width: '60px'
            },
        ]
    }

    $scope.studentsGridSettings = {
        name: 'selectedMembershipStudents',
        shouldShowColumnChooser: true,
        columns: [
            { dataField: 'membershipStudentID', caption: $translate.instant('TXT_LBL_ID'), dataType: 'number', visible: false },
            { dataField: 'student', caption: $translate.instant('TXT_LBL_STUDENT'), dataType: 'string', sortOrder: 'desc' },
            { dataField: 'notes', caption: $translate.instant('TXT_LBL_NOTES'), dataType: 'string', visible: false },
            { dataField: 'birthday', caption: $translate.instant("TXT_LAB_BIRTHDAY"), dataType: 'date', format: { date: 'short' }, width: '100px'},
            { dataField: 'parent', caption: $translate.instant('TXT_LBL_PARENT'), dataType: 'string', width: '140px' },
            { dataField: 'email', caption: $translate.instant('TXT_LBL_EMAIL'), dataType: 'string', width: '240px' },
            {
                dataField: 'phone',
                caption: $translate.instant('TXT_LBL_PHONE'),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('phone')(rowData.phone);
                },
                width: '120px'
            },
            { dataField: 'price', caption: $translate.instant('TXT_LBL_PRICE'), dataType: 'number', format: { type: 'currency', precision: 2 }, width: '90px' },
            {
                dataField: 'discountPct', caption: $translate.instant('TXT_LBL_DISCOUNT_PCT'), dataType: 'number',
                format: function (value) {
                    return $filter('wbPercent')(value);
                }, width: '60px'
            },
            { dataField: 'createdAt', caption: $translate.instant("TXT_LBL_CREATED_AT"), dataType: 'date', format: 'shortDateShortTime', width: '110px' },
            {
                dataField: 'invoiceID',
                caption: $translate.instant('TXT_LAB_INVOICE'),
                dataType: 'boolean',
                calculateCellValue: function (rowData) {
                    return !!rowData.invoiceID;
                },
                width: '60px',
                visible: false
            },
            { dataField: 'isValid', caption: $translate.instant('TXT_LAB_VALID'), dataType: 'boolean', width: '60px' },
        ],
        shouldDisableAdd: function () { return !$scope.selectedRow.id; },
        customCommands: [{
            text: $translate.instant('TXT_MENU_PRINT_INVOICE'),
            isVisible: function (row) { return securitySvc.isInRole('Reports') && securitySvc.isInRole('CourseRegistration.PrintInvoice') && !!row.invoiceID; },
            callback: function (data) { onPrintInvoice(data.invoiceID); }
        }]
    }

    function onPrintInvoice(invoiceID) {
        $window.open('/Admin/Report/Invoice?ReportID=' + invoiceID + '&ReportIDType=1',
            '_blank', 'width=1000,height=500,toolbar=no,resizable=yes,location=no,directories=no,status=no,menubar=no,copyhistory=no');
    }

    //#region Membership Detail

    $scope.membershipDetail = {};
    $scope.membershipDetailOrig;

    $scope.onRowEdit = function (data) {
        $scope.membershipDetail = angular.copy(data);
        $scope.membershipDetailOrig = angular.copy(data);

        detailDialogPromise.$promise.then(function () {
            $scope.detailError = null;
            $scope.detailTabs.activeTab = 0;
            detailDialogPromise.show();
        });
    }

    $scope.detailError = null;

    $scope.onRowAdd = function () {

        $scope.membershipDetail.id = -1;
        $scope.membershipDetail.name = "";
        $scope.membershipDetail.description = "";
        $scope.membershipDetail.isMandatory = true;
        $scope.membershipDetail.isClientAssignable = true;
        $scope.membershipDetail.price = 0;
        $scope.membershipDetail.discountPct = 0;
        $scope.membershipDetail.validityPeriodInDays = null;
        $scope.membershipDetail.validFrom = undefined;
        $scope.membershipDetail.validTo = undefined;
        $scope.membershipDetail.applyToActions = false;
        $scope.membershipDetail.applyToCourses = true;

        $scope.membershipDetailOrig = angular.copy($scope.membershipDetail);

        detailDialogPromise.$promise.then(function () {
            $scope.detailError = null;
            $scope.detailTabs.activeTab = 0;
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        membershipSvc.remove(data, success);

        function success() {
            $scope.selectedRow = {};
            lastSelectedMembershipId = 0;
        }
    }

    $scope.selectedRow = {};
    $scope.selectedMembershipStudents = [];

    var lastSelectedMembershipId;

    function setSelectedMembership(data) {
        $scope.selectedRow = data || {};
        if (!data) {
            $scope.selectedMembershipStudents = [];
        } else {
            if (lastSelectedMembershipId !== data.id) {
                lastSelectedMembershipId = data.id;
                $scope.selectedMembershipStudents = membershipStudentSvc.GetAllByMembershipAsync(data.id);
            }
        }
    }

    $scope.onRowSelected = function (data) {
        setSelectedMembership(data);
    }

    $scope.onMembershipDetailSave = function (data) {
        membershipSvc.save(data, function (successResult) {
            detailDialogPromise.hide();
        }, function (errorResult) {
            $scope.detailError = errorResult;
        });
    }

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.membershipDetailOrig);
    };

    $scope.detailTabs = [
        {
            title: 'TXT_MAIN',
            template: "promo/membership-detail-main-tab.html"
        },
        {
            title: "TXT_PRICE_TAB",
            template: "promo/membership-detail-price-tab.html"
        },
        {
            title: "TXT_VALIDITY_TAB",
            template: "promo/membership-detail-validity-tab.html"
        }
    ];

    $scope.detailTabs.activeTab = 0;

    var detailDialogPromise = $modal({
        templateUrl: 'promo/membership-detail.html',
        show: false,
        scope: $scope
    });

    //#endregion

    //#region Membership student detail

    $scope.membershipStudentDetail = {};
    $scope.membershipStudentDetailOrig;
    $scope.membershipStudentDetailError = null;

    $scope.onMSRowEdit = function (data) {
        $scope.membershipStudentDetail = angular.copy(data);
        $scope.membershipStudentDetailOrig = angular.copy(data);

        membershipStudentDetailDialogPromise.$promise.then(function () {
            $scope.membershipStudentDetailError = null;
            membershipStudentDetailDialogPromise.show();
        });
    }

    $scope.onMSRowAdd = function () {
        $scope.membershipStudentDetail.membershipStudentID = null;
        $scope.membershipStudentDetail.studentID = null;
        $scope.membershipStudentDetail.notes = null;
        $scope.membershipStudentDetail.membershipID = $scope.selectedRow.id;
        if ($scope.selectedRow.validityPeriodInDays) {
            $scope.membershipStudentDetail.validFrom = new Date();
            $scope.membershipStudentDetail.validTo = moment($scope.membershipStudentDetail.validFrom)
                .add('d', $scope.selectedRow.validityPeriodInDays)
                .toDate();
        } else {
            $scope.membershipStudentDetail.validFrom = $scope.selectedRow.validFrom;
            $scope.membershipStudentDetail.validTo = $scope.selectedRow.validTo;
        }
        $scope.membershipStudentDetail.price = 0;
        $scope.membershipStudentDetail.discountPct = $scope.selectedRow.discountPct;
        $scope.membershipStudentDetail.applyToCourses = $scope.selectedRow.applyToCourses;
        $scope.membershipStudentDetail.applyToActions = $scope.selectedRow.applyToActions;
        $scope.membershipStudentDetail.isNew = true;

        $scope.membershipStudentDetailOrig = angular.copy($scope.membershipStudentDetail);

        membershipStudentDetailDialogPromise.$promise.then(function () {
            $scope.membershipStudentDetailError = null;
            membershipStudentDetailDialogPromise.show();
        });
    }

    $scope.onMSRowDelete = function (data) {
        membershipStudentSvc.remove(data);
    }

    $scope.membershipStudentDetailIsUnchanged = function (data) {
        return angular.equals(data, $scope.membershipStudentDetailOrig);
    };

    $scope.onMembershipStudentDetailSave = function (data) {
        if (data.isNew) {
            membershipStudentSvc.insert(data, success, error);
        } else {
            membershipStudentSvc.update(data, success, error);
        }

        function success() {
            membershipStudentDetailDialogPromise.hide();
        }

        function error(errorResult) {
            $scope.membershipStudentDetailError = errorResult;
        }
    }

    //#endregion

    var membershipStudentDetailDialogPromise = $modal({
        templateUrl: 'promo/membership-student-detail.html',
        show: false,
        scope: $scope
    });

    //#endregion

    $scope.tabs = [
        {
            title: 'TXT_DETAIL',
            template: "membership/detail-tabs/home.html"
        },
        {
            title: 'TXT_LBL_STUDENTS',
            template: "membership/detail-tabs/students.html"
        }
    ];

    $scope.tabs.activeTab = 0;

    $scope.$watch('tabs.activeTab', function (newValue, oldValue) {
        $scope.$broadcast('activeTabChanged', { activeTab: newValue });
    });

}]);